<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('OLDPASSWORD')">
        <inputvalidation :formerror="formError" name="oldPassword">
          <b-form-input type="password" v-model="formData.oldPassword"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('PASSWORD')">
        <inputvalidation :formerror="formError" name="password">
          <b-form-input type="password" v-model="formData.password"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('CONFIRMPASSWORD')">
        <inputvalidation :formerror="formError" name="password2">
          <b-form-input type="password" v-model="formData.password2"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default
{
    name: 'PasswordForm',
    props: ['formData', 'formError'],
};
</script>
